import React from 'react';
import { motion } from 'framer-motion';
import ProjectStatsBadge from '../../../components/ProjectStatsBadge';
import ShareProjectButton from '../../../components/ShareProjectButton/ShareProjectButton';
import './cloudvendor-app-using-java-springboot-using-mysql-jdbc.css';
import cloudVendorImage from '../../../assets/images/CloudVendor App Image.png';

const CloudVendorApp = () => {
  return (
    <motion.div 
      className="project-detail-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <motion.h1 
        className="project-heading"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        CloudVendor <span>App</span> using Java Spring Boot & MySQL JDBC
      </motion.h1>

      <motion.p 
        className="last-updated"
        initial={{ x: 50, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      ><br />
        Last Updated On: 20th June 2025
      </motion.p>

      <div className="project-content">
        <motion.div 
          className="project-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <img src={cloudVendorImage} alt="CloudVendor App" className="project-image" />
          <h2 className="project-subtitle">CloudVendor Management Application</h2>
          <span className="project-category">Software</span>
          <p className="project-author">Author: Praveen Kumar B</p>

          <ProjectStatsBadge docId="cloudVendorApp" trackView={true} />

          {/* Buttons */}
          <div className="project-buttons">
            <a href="/under-construction" className="visit-project-button">
              → Visit the Project
            </a>
            <a href="https://github.com/Praveenkumar-king/Java-Springboot-JDBC-powered-CloudVendor-app" className="visit-project-button">
              → View on GitHub
            </a>
            <ShareProjectButton
              project={{
                id: "cloudVendorApp",
                title: "CloudVendor App using Java Spring Boot & MySQL JDBC",
                path: "/projects/projectdetail/cloudvendor-app-using-java-springboot-using-mysql-jdbc"
              }}
            />
          </div>
        </motion.div>

        <motion.div 
          className="project-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <h3 className="section-title">Project Details</h3>
          <p className="overview-text">
            Hello Developers & Tech Enthusiasts 💻☁️! Here's a deep dive into my Java + Spring Boot + MySQL-based application.
          </p>

          <h3 className="section-title">Overview ✨</h3>
          <p className="overview-description">
            The <strong>CloudVendor Management App</strong> is a backend service built with Java, Spring Boot, and MySQL using JDBC to demonstrate core **CRUD operations**. It provides a simple yet robust RESTful API to manage cloud service vendor details. The system allows you to **Create, Read, Update, Delete (CRUD)** vendor data efficiently with real-time database synchronization. 🛠️📦
          </p>

          <h3 className="section-title">Key Features 🛠️</h3>
          <ul className="feature-list">
            <li>Spring Boot Framework 🚀 - Lightweight and production-ready Java backend framework.</li>
            <li>MySQL Integration 📂 - Relational database using JDBC for data persistence.</li>
            <li>CRUD APIs 🔁 - Full support for Create, Read, Update, Delete operations.</li>
            <li>RESTful Design 🌐 - Exposes REST endpoints to manage CloudVendor resources.</li>
            <li>Data Validation ✅ - Validates input fields and ensures consistency.</li>
            <li>Error Handling 🚧 - Robust exception handling using Spring’s mechanisms.</li>
            <li>Lightweight Architecture 🧱 - Focused design for understanding Spring Boot fundamentals.</li>
            <li>Postman Test Ready 📬 - Easily test endpoints using Postman.</li>
          </ul>

          <h3 className="section-title">Benefits 🌟</h3>
          <ul className="benefits-list">
            <li><strong>Learn Core Spring Boot Concepts</strong> 📚 - From Controllers to Services & Repositories.</li>
            <li><strong>Hands-On JDBC</strong> 🔗 - Understand how Java directly connects to relational databases.</li>
            <li><strong>Modular Design</strong> 🧩 - Clean separation of concerns for scalable development.</li>
            <li><strong>Reusable Templates</strong> 📑 - Easily extend for other entity-based systems.</li>
            <li><strong>Production-Oriented</strong> ⚙️ - Base for scalable enterprise backend apps.</li>
          </ul>

          <h3 className="section-title">How It Works 🔍</h3>
          <ul className="how-it-works-list">
            <li><strong>Setup</strong> 🔧 - Spring Boot application connected to MySQL via JDBC.</li>
            <li><strong>Model Layer</strong> 📦 - Defines CloudVendor entity with appropriate fields.</li>
            <li><strong>Repository Layer</strong> 🗄️ - JDBC logic to interact with the database.</li>
            <li><strong>Service Layer</strong> 🧠 - Business logic for processing requests.</li>
            <li><strong>Controller Layer</strong> 🕹️ - REST API endpoints exposed to the client.</li>
            <li><strong>Testing</strong> 🧪 - Test API using Postman or Swagger UI.</li>
          </ul>

          <h3 className="section-title">Why Build This? 🤔</h3>
          <ul className="how-it-works-list">
            <li>To master the fundamentals of **Spring Boot and Java backend** development. 🧠</li>
            <li>To implement practical **CRUD operations** using JDBC. 📄</li>
            <li>To understand the complete flow from **HTTP Request → MySQL Database**. 🔄</li>
            <li>To create a base structure for future **enterprise-level backend systems**. 💼</li>
          </ul>

          <h3 className="section-title">Conclusion 🎯</h3>
          <p>
            The <strong>CloudVendor App</strong> is a perfect starting point for anyone diving into backend development with Java & Spring Boot. With clean architecture, real database sync, and all core functionalities, it serves as both a portfolio project and a learning playground. 💡🔥
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default CloudVendorApp;
